module.exports = __webpack_public_path__ + "img/Csorbics_580x440.1038e700.png";